import {
  fetchRecommendationsFulfilled,
  fetchRecommendationsPending,
  fetchRecommendationsRejected,
} from '../../actions/recommendations';
import { prepareRecommendations } from '../../mappers/prepareRecommendations';
import {
  TGetFavoritesRecommendationsResponse,
  fetchGetFavoritesRecommendations,
} from '../../repositories/favorites/v1/get-favorites-recommendations';
import { TThunkAction } from '../../types/redux';

const INITIAL_PAGE = 0;

export const getRecommendations =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger }) => {
    dispatch(fetchRecommendationsPending());

    try {
      const { statusCode, response }: TGetFavoritesRecommendationsResponse = await fetchGetFavoritesRecommendations({
        httpApi,
        parameters: {
          page: INITIAL_PAGE,
          category: 'all',
        },
      });

      if (statusCode === 200) {
        dispatch(
          fetchRecommendationsFulfilled({
            data: prepareRecommendations(response.items),
            hasMore: !!response.canLoadMore,
          }),
        );
      }

      if (statusCode === 400) {
        dispatch(fetchRecommendationsRejected());

        logger.warning(response.message || 'Failed to get Recommendations (400 status code)');
      }
    } catch (e) {
      dispatch(fetchRecommendationsRejected());

      logger.error(e, { description: 'Failed to get Recommendations' });
    }
  };
